import { LuArrowRight } from 'react-icons/lu';
import type { ReactNode } from 'react';
import styles from './button.module.scss';

export type ButtonVariant = 'primary' | 'secondary';

type ButtonProps = {
    children: ReactNode;
    variant?: ButtonVariant;
    icon?: ReactNode;
    showArrow?: boolean;
    disabled?: boolean;
    type?: 'button' | 'submit';
    onClick?: () => void;
    className?: string;
};

export const Button = ({
    children,
    variant = 'primary',
    icon,
    showArrow = false,
    disabled = false,
    type = 'button',
    onClick,
    className = '',
}: ButtonProps) => {
    const variantClass = variant === 'primary' ? styles.primary : styles.secondary;

    return (
        <button
            type={type}
            className={`${styles.button} ${variantClass} ${className}`.trim()}
            onClick={onClick}
            disabled={disabled}
        >
            {icon}
            {children}
            {showArrow && (
                <span className={styles.icon}>
                    <LuArrowRight size={18} color="currentColor" />
                </span>
            )}
        </button>
    );
};
